/**
 * Neighborhood-style Lens Zoom
 */
(() => {
  const initLens = (root) => {
    if (root.classList.contains('lz-initialized')) return;
    const img = root.querySelector('img[data-lens-zoom-image]');
    if (!img) return;

    const zoom = parseFloat(root.dataset.lzZoom || 2.5);
    const lensSize = parseInt(root.dataset.lzLens || 200);

    const lens = document.createElement('div');
    lens.className = 'lz-lens';
    lens.style.width = `${lensSize}px`;
    lens.style.height = `${lensSize}px`;
    root.appendChild(lens);
    root.classList.add('lz-initialized');

    const update = (e) => {
      const rect = root.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Position lens
      lens.style.left = `${x - lensSize / 2}px`;
      lens.style.top = `${y - lensSize / 2}px`;

      // Zoom math
      const bgX = (x * zoom) - (lensSize / 2);
      const bgY = (y * zoom) - (lensSize / 2);
      
      lens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
      lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
    };

    root.addEventListener('mouseenter', () => {
      const highRes = img.getAttribute('data-max-resolution') || img.currentSrc || img.src;
      lens.style.backgroundImage = `url("${highRes}")`;
      root.classList.add('lz-active');
    });

    root.addEventListener('mouseleave', () => root.classList.remove('lz-active'));
    root.addEventListener('mousemove', (e) => window.requestAnimationFrame(() => update(e)));
  };

  const setup = () => document.querySelectorAll('[data-lens-zoom]').forEach(initLens);
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  
  // Shopify specific: Re-run when variants change or sections reload
  document.addEventListener('shopify:section:load', setup);
})();